// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"dW-z","inlineTitle":"eW-z","sponsoredAdsWrapper":"fW-z","marketplaceRecosWrapper":"gW-z"};